import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import NumberField from '../components/NumberField';
import Typography from '@material-ui/core/Typography';


const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: `0 ${theme.spacing.unit * 3}px`,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
  option: {
    margin: `${theme.spacing.unit * 7}px 0`,
  },
});


class LicenseCountForm extends React.Component {

  state = {
    explainLicenses: false,
  }


  toggleLicenseHelpPopover = () => {
    this.setState({explainLicenses: !this.state.explainLicenses})
  };


  render = () => {
    const {order, actions, smallScreen} = this.props
    const {explainLicenses} = this.state

    return (
      <div style={{marginLeft: 24}}>
        <Grid container spacing={16}>
          <Grid item xs={12} sm={12}>
            <Grid item xs={12} sm={12}>
              <Typography>
                How many people will be using this book?
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                style={{marginTop:12, marginLeft:4}}
                label={`Book Licenses`}
                control={
                  <NumberField
                    min={1}
                    value={order.numberOfLicenses}
                    onChange={newVal => actions.setNumberOfLicenses(order, newVal)}
                    />
                }
              />
            </Grid>
            <br/>
            <br/>
          </Grid>
          {/* <Grid item xs={6} sm={6}>
            <Grid item xs={12} sm={12}>
              <Typography>
                And how many <em>also</em> need a printed copy?
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                style={{marginLeft:4, marginTop: 12, marginBottom:12}}
                label={`Printed Books`}
                control={
                  <NumberField
                    min={0}
                    value={order.numberOfPrintedBooks}
                    onChange={newVal => actions.setNumberOfPrintedBooks(order, newVal)}
                  />
                }
              />
            </Grid>
          </Grid> */}
        </Grid>


        <Grid container spacing={24}>
          <Grid item xs={12} sm={12}>
            <Button onClick={this.toggleLicenseHelpPopover} color="primary" style={{textTransform: 'none', marginLeft: -12}}>
              {/* How many Licenses are needed, and what are Printed Books? */}
              How many Licenses are needed?
            </Button>
            <Dialog open={explainLicenses} onClose={this.toggleLicenseHelpPopover} fullScreen={smallScreen}>
              <DialogTitle>
                {/* Book Licenses and Printed Books */}
                Book Licenses
              </DialogTitle>
              <DialogContent>
                <Typography variant="body1" component="div">
                  {/* <ol>
                    <li style={{marginBottom: '1em'}}>
                      <p>
                        <b>Book Licenses</b>: You MUST have one license for each person
                        that uses the flat-rate pricing, whether they use a digital
                        device or a printed book.
                      </p>
                      <p>
                        Each person with a license can search and (if you chose) update
                        your flat-rate pricing. Technicians can look up pricing,
                        from any: computer, tablet, or smartphone (<span style={{color: 'red'}}>internet connection required</span>).
                      </p>
                    </li>
                    <li>
                      <p>
                        <b>Printed Books</b>:
                        Great for technicians that won't have access to an internet connection
                        in the field.
                      </p>
                      <p>
                        Printed, assembled, and shipped directly to you. These three-ring
                        bound price books can be used by your technicians to look up and
                        quote repair fees to your customers (there is some additional cost
                        for printing and shipping.)
                      </p>
                      <p>

                      </p>
                    </li>
                  </ol> */}
                  <p>
                    <b>Book Licenses</b>: You MUST have one license for each person
                    that uses the flat-rate pricing, whether they use a digital
                    device or a printed book.
                  </p>
                  <p>
                    Each person with a license can search and (if you chose) update
                    your flat-rate pricing. Technicians can look up pricing
                    from any: computer, tablet, or smartphone (<span style={{color: 'red'}}>internet connection required</span>).
                  </p>
                </Typography>
              </DialogContent>
              <DialogActions style={{padding: '1em'}}>
                <Button onClick={this.toggleLicenseHelpPopover} variant="contained" color="primary" autoFocus>
                  Got It
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>

      </div>
    )
  }
}

LicenseCountForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(LicenseCountForm);
